import React from "react";
import './Destination.css';

import { filterToursByLocation } from "../../utils";

import { Link } from "react-router-dom";



const Destination = ({ destination }) => {

  // Get Destination Tours Length
  const desToursLength = filterToursByLocation(destination.title).length;

    return (

        <div className={`destination-item des-${destination.id}`} key={destination.id}>

            <img src={destination.image} alt={`des-${destination.id}`} /> 

            <div className="content">

                <p>{desToursLength} Tours</p>

                {/* Link to the individual Destination page */}
                <Link
                    to={{
                        pathname: '/Destinations/' + destination.title,  // Navigate to the specific Destination page
                    }}
                    location = {{destination}}  // Passing Destination details to the linked page
                    className="main-heading"
                    state= {destination}> 
                    {destination.title} {/* Destination Title */}
                </Link>

            </div>

        </div>
    );
};

export default Destination;